export enum ReportTypes {
  a4 = 'DEFAULT_A4',
  continuousForm = 'CONTINIOUS_FORM',
  thermal = 'THERMAL_PRINTER',
  thermal58mm = 'THERMAL_PRINTER_58MM',
}

export enum DefaultName {
  corporateReason = 'CORPORATE_NAME',
  fantasyName = 'FANTASY_NAME',
}

export enum AdministrativeReportCode {
  manufacturerCode = 'MANUFACTURER_CODE',
  internalCode = 'INTERNAL_CODE',
  barCode = 'BARCODE',
  companyCode = 'COMPANY_CODE',
}

export interface CompanyReportFormValues {
  administrativeReportFormat: ReportTypes;
  workshopReportFormat: ReportTypes;
  quotationMapReportFormat: ReportTypes;
  showObservation: boolean;
  showEngine?: boolean;
  companyNaming: DefaultName;
  administrativeReportCode: AdministrativeReportCode;
  id: string;
}

export interface CompanyReportRequest extends CompanyReportFormValues {
  companyId: number;
}
